var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.476 338.285C395.959 252.792 389.11 263.458 390.68 261.229C410.516 233.251 421 200.322 421 166C421 74.98 347.139 0 256 0C165.158 0 91 74.832 91 166C91 200.3 101.704 234.091 122.19 262.446L170.522 338.286C118.847 346.227 31 369.892 31 422C31 440.995 43.398 468.065 102.462 489.159C143.704 503.888 198.231 512 256 512C364.025 512 481 481.528 481 422C481 369.883 393.256 346.243 341.476 338.285ZM147.249 245.945C147.084 245.687 146.912 245.435 146.732 245.187C129.685 221.735 121 193.941 121 166C121 90.982 181.406 30 256 30C330.439 30 391 91.009 391 166C391 193.986 382.479 220.837 366.354 243.671C364.909 245.577 372.448 233.865 256 416.589L147.249 245.945ZM256 482C138.006 482 61 447.317 61 422C61 404.984 100.568 377.005 188.248 366.099L243.35 452.562C246.104 456.884 250.874 459.5 255.999 459.5C261.124 459.5 265.895 456.883 268.648 452.562L323.749 366.099C411.431 377.005 451 404.984 451 422C451 447.102 374.687 482 256 482Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 91C214.645 91 181 124.645 181 166C181 207.355 214.645 241 256 241C297.355 241 331 207.355 331 166C331 124.645 297.355 91 256 91ZM256 211C231.187 211 211 190.813 211 166C211 141.187 231.187 121 256 121C280.813 121 301 141.187 301 166C301 190.813 280.813 211 256 211Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic-location.18989f1b60923641ea85995f174d9c44.svg";
export { ForwardRef as ReactComponent };